"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelectionInfo = void 0;
var _ykbStyledComponents = require("../../ykb-styled-components");
var StyledSelectionInfo = exports.StyledSelectionInfo = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-1fi1trl-0"
})(["align-self:flex-start;justify-self:center;line-height:30px;height:30px;flex:1;"]);